import axios from "axios";

// 1. Create the base axios instance with default settings.
const axiosTuri = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
});

// 2. Add a REQUEST interceptor to attach the Bearer token to every outgoing request.
axiosTuri.interceptors.request.use(
  (config) => {
    // Get the token from localStorage right before the request is sent.
    const token = localStorage.getItem("token");

    // If a token exists, add the Authorization header.
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // Handle request errors (e.g., network issues)
    return Promise.reject(error);
  }
);

// 3. (CRUCIAL ADDITION) Add a RESPONSE interceptor to handle global errors.
axiosTuri.interceptors.response.use(
  // If the response is successful (status 2xx), just return it.
  (response) => {
    return response;
  },
  // If the response has an error...
  (error) => {
    // Check if the error is a 401 Unauthorized.
    // This means the token is invalid or expired.
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized (401). Token is bad. Logging out.");

      // The token is bad, so remove it from storage to prevent sending it again.
      localStorage.removeItem("token");

      // Reload the application. This is the cleanest way to force the user
      // back to the login page and reset all application state.
      // window.location.reload();
    }

    // For all other errors (404, 500, etc.), just pass them along
    // to be handled by the component's .catch() block.
    return Promise.reject(error);
  }
);

export default axiosTuri;
